import { UserCog } from 'lucide-react';
import { UserUpdatedEvent as UserUpdatedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: UserUpdatedEventType;
}

export default function UserUpdatedEvent({ event }: Props) {
  return (
    <EventShell
      color="blue"
      icon={<UserCog className="w-3.5 h-3.5" />}
      title="User Updated"
      timestamp={event.created_at}
    >
      {event.payload.updated_fields && event.payload.updated_fields.length > 0 && (
        <p>Updated: {event.payload.updated_fields.join(', ')}</p>
      )}
      {event.payload.source && <p>Source: {event.payload.source}</p>}
    </EventShell>
  );
}
